import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
export function ContentSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-24 bg-gradient-to-b from-turquoise/90 to-deepBlue/90 px-4" data-id="element-28">
      <div className="max-w-7xl mx-auto flex flex-col items-center" data-id="element-29">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-bold text-white mb-6 text-center max-w-4xl leading-tight" data-id="element-30">
          ¿Qué vas a encontrar dentro del MegaPack?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-white/90 max-w-3xl mb-16 text-center" data-id="element-31">
          Todo lo que necesitás para cursar sin estrés, organizado y listo para
          usar.
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full mb-20" data-id="element-32">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-xl hover:-translate-y-2 transition-transform duration-300" data-id="element-33">
            <div className="text-5xl mb-6" data-id="element-34">📚</div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-35">
              Tomo 1: Organización y Planificación
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-36">
              Herramientas para planificar tus materias, parciales y entregas
              desde el primer día.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-xl hover:-translate-y-2 transition-transform duration-300" data-id="element-37">
            <div className="text-5xl mb-6" data-id="element-38">📋</div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-39">
              Tomo 2: Técnicas de Estudio
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-40">
              Métodos probados para estudiar mejor en menos tiempo y retener más
              información.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-xl hover:-translate-y-2 transition-transform duration-300" data-id="element-41">
            <div className="text-5xl mb-6" data-id="element-42">🧠</div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-43">
              Tomo 3: Rendimiento y Bienestar
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-44">
              Energía, foco y descanso para rendir sin quemarte.
            </p>
          </motion.div>

          {/* Card 4 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-xl hover:-translate-y-2 transition-transform duration-300" data-id="element-45">
            <div className="text-5xl mb-6" data-id="element-46">📄</div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-47">
              Tomo 4: Gestión del Tiempo
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-48">
              Calendarios y planillas imprimibles para organizar cada semana de
              tu cursada.
            </p>
          </motion.div>

          {/* Card 5 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-xl hover:-translate-y-2 transition-transform duration-300 lg:col-span-2 lg:max-w-2xl lg:mx-auto" data-id="element-49">
            <div className="text-5xl mb-6" data-id="element-50">🛡️</div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-51">
              Tomo 5: Exámenes Sin Pánico
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-52">
              Estrategias paso a paso para afrontar exámenes con confianza y sin
              estrés.
            </p>
          </motion.div>
        </motion.div>

        {/* Bonuses Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="w-full flex flex-col items-center" data-id="element-53">
          <h3 className="text-2xl md:text-3xl font-bold text-goldenYellow mb-12 text-center flex items-center gap-3" data-id="element-54">
            <span className="text-4xl" data-id="element-55">🎁</span> ¡3 Bonos Especiales gratis solo
            por hoy!
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-5xl mb-10" data-id="element-56">
            {/* Bonus 1 */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 flex flex-col items-center text-center hover:bg-white/20 transition-colors duration-300" data-id="element-57">
              <div className="w-16 h-16 bg-coralOrange/20 rounded-full flex items-center justify-center mb-4" data-id="element-58">
                <BookOpenIcon className="w-8 h-8 text-coralOrange" data-id="element-59" />
              </div>
              <h4 className="text-lg font-bold text-white mb-3" data-id="element-60">
                Kit de Productividad Digital
              </h4>
              <div className="flex items-center gap-2" data-id="element-61">
                <span className="text-white/50 line-through text-sm" data-id="element-62">
                  $4.999
                </span>
                <span className="bg-goldenYellow text-deepBlue font-bold text-sm px-3 py-1 rounded-full" data-id="element-63">
                  $0 — GRATIS HOY
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 flex flex-col items-center text-center hover:bg-white/20 transition-colors duration-300" data-id="element-64">
              <div className="w-16 h-16 bg-turquoise/20 rounded-full flex items-center justify-center mb-4" data-id="element-65">
                <BookOpenIcon className="w-8 h-8 text-turquoise" data-id="element-66" />
              </div>
              <h4 className="text-lg font-bold text-white mb-3" data-id="element-67">
                Técnicas de Concentración y Enfoque
              </h4>
              <div className="flex items-center gap-2" data-id="element-68">
                <span className="text-white/50 line-through text-sm" data-id="element-69">
                  $3.999
                </span>
                <span className="bg-goldenYellow text-deepBlue font-bold text-sm px-3 py-1 rounded-full" data-id="element-70">
                  $0 — GRATIS HOY
                </span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 flex flex-col items-center text-center hover:bg-white/20 transition-colors duration-300" data-id="element-71">
              <div className="w-16 h-16 bg-softViolet/20 rounded-full flex items-center justify-center mb-4" data-id="element-72">
                <BookOpenIcon className="w-8 h-8 text-softViolet" data-id="element-73" />
              </div>
              <h4 className="text-lg font-bold text-white mb-3" data-id="element-74">
                Bienestar Universitario: Guía Práctica
              </h4>
              <div className="flex items-center gap-2" data-id="element-75">
                <span className="text-white/50 line-through text-sm" data-id="element-76">
                  $3.499
                </span>
                <span className="bg-goldenYellow text-deepBlue font-bold text-sm px-3 py-1 rounded-full" data-id="element-77">
                  $0 — GRATIS HOY
                </span>
              </div>
            </div>
          </div>

          <p className="text-white/80 text-lg text-center font-medium" data-id="element-78">
            Para una cursada completa, organizada y sin estrés.
          </p>
        </motion.div>
      </div>
    </section>;
}